import { render, staticRenderFns } from "./btns-list.vue?vue&type=template&id=53228783&"
import script from "./btns-list.vue?vue&type=script&lang=js&"
export * from "./btns-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports